import React from 'react';
import PropTypes from 'prop-types';
import SearchPrimaryFilter from './SearchPrimaryFilter';
import MaxWidthContainer from '../Global/Containers/MaxWidthContainer';
import HorizontalScroll from '../Global/Containers/HorizontalScroll';
import contentTypeName from '../../utils/contentTypeName';

const SearchPrimaryFilters = ({ activeFilter, searchResults, onClick }) => {
  const listItemClass = `primary-filters__list-item`;

  return (
    <div className="border-bottom-1 border-color-grey--light">
      <MaxWidthContainer>
        <HorizontalScroll constant>
          <ul className="primary-filters faux-list">
            <li className={listItemClass}>
              <SearchPrimaryFilter
                onClick={onClick}
                value="all"
                active={contentTypeName(activeFilter) === contentTypeName(`all`)}
              />
            </li>

            {searchResults.result_count.map(filter => (
              filter.itemName !== `` && (
                <li key={filter.itemName} className={listItemClass}>
                  <SearchPrimaryFilter
                    onClick={onClick}
                    value={filter.itemName}
                    active={contentTypeName(activeFilter) === contentTypeName(filter.itemName)}
                  />
                </li>
              )
            ))}
          </ul>
        </HorizontalScroll>
      </MaxWidthContainer>
    </div>
  );
};

SearchPrimaryFilters.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  searchResults: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SearchPrimaryFilters;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchPrimaryFilters.js